// extracted by mini-css-extract-plugin
var _1 = "InputWrapError-moduleInputWrapError__sjLrO";
export { _1 as "InputWrapError" }
